module.exports = function getResource(label, vars = []) {
    const resources = {
        error: 'Erreur',
        submissionError: 'Un problème est survenu lors du traitement de votre soumission. Veuillez réessayer plus tard.'
    };

    return resources[label];
};
